import React from 'react'
import {Icon} from 'components/Icons'
import {LogoWrapper} from './style'

export const FoundationLogo = ({light,active})=>(
    <LogoWrapper light={light} active={active} to="/">
        <Icon type='foundation-logo' color={light&&!active?'black':'white'} width={'100%'}/>
    </LogoWrapper>
)


